import { render, staticRenderFns } from "./DeleteRecipeModal.vue?vue&type=template&id=44705b55"
import script from "./DeleteRecipeModal.vue?vue&type=script&lang=js"
export * from "./DeleteRecipeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports